import { call, put, take } from "redux-saga/effects";
import {
  GetScriptsSchema,
  GetWorkflowsSchema,
  WorkflowConst,
  getAllScriptsErrorAction,
  getAllScriptsLoadingAction,
  getAllScriptsSuccessAction,
  getAllWorkflowsErrorAction,
  getAllWorkflowsLoadingAction,
  getAllWorkflowsSuccessAction,
  initWorkflowTemplateJSONSuccessAction
} from "../actions/workflowActions";
import { httpGet } from "../../services";

function* getAllWorkflowsHandler() {
  try {
    yield put(getAllWorkflowsLoadingAction());

    const data: GetWorkflowsSchema = yield httpGet("/deployment/orchestration/workflows", {});
    const stateData = data.ErrorCode ? { Data: [] } : data;
    yield put(getAllWorkflowsSuccessAction({ ...stateData }));
  } catch (e) {
    yield put(getAllWorkflowsErrorAction(e.message));
  }
}

function* getAllScriptsHandler() {
  try {
    yield put(getAllScriptsLoadingAction());

    const data: GetScriptsSchema = yield httpGet("/deployment/orchestration/scripts", {});

    const stateData = data.ErrorCode ? { Data: [] } : data;
    yield put(getAllScriptsSuccessAction({ ...stateData }));
  } catch (e) {
    yield put(getAllScriptsErrorAction(e.message));
  }
}

export function* watchGetAllWorkflows() {
  while (true) {
    yield take(WorkflowConst.GET_ALL_WORKFLOWS);
    yield call(getAllWorkflowsHandler);
  }
}

export function* watchGetAllScripts() {
  while (true) {
    yield take(WorkflowConst.GET_ALL_SCRIPTS);
    yield call(getAllScriptsHandler);
  }
}

function* getWorkflowTemplateData() {
  const workflowTemplateJSON = window.getWorkflowTemplatesJSON();
  yield put(initWorkflowTemplateJSONSuccessAction({ data: workflowTemplateJSON }));
}

export function* watchInitWorkflowTemplateJSON() {
  while (true) {
    yield take(WorkflowConst.INIT_WORKFLOW_TEMPLATE);
    yield call(getWorkflowTemplateData);
  }
}
